<template>
  <div class="WordWithUnderline">
    {{ words }}
    <div class="underline"></div>
  </div>
</template>

<script>
export default {
  name: "WordWithUnderline",
  props: {
    words: {
      type: String,
      require: true,
    },
  },
};
</script>

<style lang="less" scoped>
.WordWithUnderline {
  font-size: @underlineWidth;
  color: @primaryColor;
  font-weight: 500;
  letter-spacing: 1px;
}

.underline {
  width: @underlineWidth;
  height: 2px;
  margin-top: 18px;
  background: @primaryColor;
}
</style>



// WEBPACK FOOTER //
// src/components/WordWithUnderline.vue